module.exports = __webpack_public_path__ + "static/media/01.cabe4a92.jpg";